import React, { useEffect } from 'react';
import { useT } from 'talkr';
import s from './index.module.scss';
import beforeImg from './img/before@2x.png';
import afterImg from './img/after@2x.png';
import Tag from './components/Tag';
import steps from '../../../survey/steps';
import common from '../../index.module.scss';

function BeforeAfterC () {
	const { T } = useT();
	useEffect(() => {
		steps.setStepStatus({
			stepName: 'before_after_c',
			stepStatus: true
		});
	}, []);

	function goForward () {
		steps.navigate.forward({
			preventAction: 500
		});
	}

	const tags = [
		{
			id: 1,
			title: '-17%',
			text: T('firstPageQuestionA_label_1')
		},
		{
			id: 2,
			title: '-11%',
			text: T('firstPageQuestionA_label_2')
		},
		{
			id: 3,
			title: '-21%',
			text: T('firstPageQuestionA_label_3')
		},
		{
			id: 4,
			title: '-16%',
			text: T('firstPageQuestionA_label_4')
		}
	];

	return (
		<div className={common.step}>
			<div className={s.page}>
				<div className={s.subtitle}>{T('firstPageQuestion_description')}</div>
				<div className={s.title}>{T('firstPageQuestionA_title')}</div>
				<div className={s.contentContainer}>
					<div className={s.img1Container}>
						<img className={s.img} src={beforeImg} alt="" />
					</div>
					<div className={s.img2Container}>
						<img className={s.img} src={afterImg} alt="" />
					</div>
					<div className={s.contentContainer__tags}>
						{tags.map((tag) => (
							<Tag
								key={tag.id}
								index={tag.id}
								title={tag.title}
								text={tag.text}
							/>
						))}
					</div>
				</div>
				<div className={s.description}>
					<span className={s.description__text}>{T('firstPageQuestionA_textBefore')}</span>
					<span className={s.description__text}>{T('firstPageQuestionA_textAfter')}</span>
				</div>
				<div className={s.stepControlWrapper}>
					<button onClick={goForward} className={s.button} type="button">{T('firstPageQuestionA_button')}</button>
				</div>
			</div>
		</div>
	);
}

export default BeforeAfterC;
